import ICON_DOWN from '../../../public/static/ranking/icon-down.svg';
import ICON_NONE from '../../../public/static/ranking/icon-none.svg';
import ICON_UP from '../../../public/static/ranking/icon-up.svg';
import ICON_ARROW_BIG from '../../../public/static/v4/ranking/icon-arrow-big.svg';
import ICON_NEW_1ST from '../../../public/static/v4/ranking/icon-new-1st.svg';
import ICON_NONE_BIG from '../../../public/static/v4/ranking/icon-none-big.svg';
import Text from '../../common/component/Text';
import {IRankingInfo} from '../../home/common/type';

interface IProps extends IRankingInfo {
  isBig?: boolean;
  className?: string;
}

export default function RankingLabelV4({
  isBig,
  ranking,
  delta,
  className,
}: IProps) {
  const isNew = delta === 'new';
  const alt = isNew ? delta : delta > 0 ? 'up' : 'down';

  return (
    <div
      className={cn(
        'flex items-center justify-between',
        'relative rounded-5',
        className,
        {
          'w-60 h-16 px-4 bg-dark-grey-01': !isBig,
          'w-64 h-18 px-6 bg-dark-red': isBig,
        }
      )}
    >
      <Text
        className={cn('font-number relative top-1', {
          's11-bold-white': !isBig,
          's12-bold-white': isBig,
        })}
      >
        {ranking}
      </Text>
      {isNew && <img src={ICON_NEW_1ST} alt="new" />}
      {delta === 0 && (
        <img
          src={isBig ? ICON_NONE_BIG : ICON_NONE}
          className="w-5 h-2"
          alt=""
        />
      )}
      {typeof delta === 'number' && delta !== 0 && (
        <div className="flex-center gap-x-2">
          <img
            src={isBig ? ICON_ARROW_BIG : delta > 0 ? ICON_UP : ICON_DOWN}
            className={cn('w-5 h-4', {
              '-scale-y-100': isBig && delta < 0,
            })}
            alt={alt}
          />
          <Text
            className={cn('font-number relative top-1', {
              's10-bold-white opacity-50': !isBig,
              's11-bold-white opacity-70': isBig,
            })}
          >
            {Math.abs(delta)}
          </Text>
        </div>
      )}
    </div>
  );
}
